import { useDrawer } from '@core/context/DrawerContext'
import { useCallback } from 'react'
import {
    HeaderRefWrapper,
    MetaSlot,
    StyledNavigationHeader,
} from './DrawerNavigationHeader.styles'
import { DrawerNavigationHeaderProps } from './DrawerNavigationHeader.types'

const DrawerNavigationHeader = <T = unknown,>({
    config,
}: DrawerNavigationHeaderProps<T>) => {
    const { drawerState, setDrawerState } = useDrawer()
    const items: T[] = drawerState?.contentProps?.[config.itemsKey] ?? []
    const currentIndex: number =
        drawerState?.contentProps?.[config.indexKey] ?? 0
    const item: T | undefined = items[currentIndex]
    const navigationTitle = config.title(item)
    const meta = config.meta?.(item)

    const onClick = useCallback(
        (count: number) => {
            const nextIndex = currentIndex + count
            if (nextIndex < 0 || nextIndex >= items.length) return
            setDrawerState((prev) => ({
                ...prev,
                contentProps: {
                    ...prev.contentProps,
                    [config.indexKey]: nextIndex,
                },
            }))
        },
        [currentIndex, items.length, config.indexKey, setDrawerState]
    )

    const prevCallback = useCallback(() => onClick(-1), [onClick])
    const nextCallback = useCallback(() => onClick(1), [onClick])

    const isNavigable = config.navigable !== false

    return (
        <HeaderRefWrapper>
            <StyledNavigationHeader
                navigationIcon={config.icon?.(item)}
                navigationLabel={config.label?.(item)}
                navigationTitle={navigationTitle}
                navigationBadges={config.badges?.(item)}
                numberOfItems={isNavigable ? items.length : undefined}
                currentIndex={isNavigable ? currentIndex : undefined}
                prevCallback={isNavigable ? prevCallback : undefined}
                nextCallback={isNavigable ? nextCallback : undefined}
            >
                {meta && <MetaSlot>{meta}</MetaSlot>}
            </StyledNavigationHeader>
        </HeaderRefWrapper>
    )
}

export default DrawerNavigationHeader
